import {AppsyncService} from "../shared/AppsyncService";
import {oktaAuth} from "../config/OktaConfig";
import gql from "graphql-tag";
import {requestBondedReturnUploadUrl, triggerProcessBondedReturnFile} from "../../graphql/return-receipt-api/mutations";

export class BondedReturnService {

    returnReceiptAppsyncService : AppsyncService;

    constructor() {
        this.returnReceiptAppsyncService = new AppsyncService(process.env.REACT_APP_APPSYNC_RETURN_RECEIPT_ENDPOINT!, oktaAuth)
    }

    async uploadFile(file: File, onStatusUpdate: any, onCompleted: any) : Promise<any> {
        onStatusUpdate("Triggering upload of " + file.name);
        const uploadUrl = await this.returnReceiptAppsyncService.appSyncClient.mutate({
            mutation: gql(requestBondedReturnUploadUrl),
            variables: {}
        });
        console.log("Upload url ", uploadUrl);
        const uploadUrlData = (uploadUrl.data as any).requestBondedReturnUploadUrl;
        onStatusUpdate("Uploading " + file.name);
        await fetch(uploadUrlData.uploadUrl, {
            method: 'PUT',
            body: file,
            headers: {
              'Content-Type': file.type
            }
        });
        onStatusUpdate("Trigger processing");
        await this.returnReceiptAppsyncService.appSyncClient.mutate({
            mutation: gql(triggerProcessBondedReturnFile),
            variables: {
                fileId: uploadUrlData.fileId
            }
        });
        onCompleted();
    }

}
